export const URL = {
  KNOWLEDGE_BASE: {
    BASIC_SETTINGS: 'https://knowledge-base.yieldbird.com/refresher/basic-settings',
  },
} as const
